module.exports = __webpack_public_path__ + "img/layer.0433ae55.png";